import { render } from "./NewTestModal.vue?vue&type=template&id=d1275fec&ts=true"
import script from "./NewTestModal.vue?vue&type=script&lang=ts"
export * from "./NewTestModal.vue?vue&type=script&lang=ts"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__